import { Rank } from "@unum/button";
import { BackgroundColour } from "@unum/section";

export const backgroundButtonMap: Record<BackgroundColour, Rank> = {
  transparent: "primary",
  grey: "primary",
  blue: "primary",
  "dark-blue": "primary",
  "light-blue": "primary",
  orange: "primary",
  gradient: "tertiary",
  primary_blue: "tertiary",
  blue_d1: "tertiary",
  blue_l2: "tertiary",
  slate: "tertiary",
  slate_l1: "tertiary",
  slate_l2: "primary",
  slate_l3: "primary",
  primary_orange: "tertiary",
  orange_d2: "tertiary",
  orange_l2: "tertiary",
  orange_l3: "primary",
  orange_l4: "primary",
  lawn: "tertiary",
  lawn_l3: "primary",
  pool: "tertiary",
  pool_l3: "primary",
  gold: "tertiary",
  sky: "tertiary",
  sky_l3: "primary",
  kiwi: "primary",
  kiwi_l3: "primary",
  warm_neutral: "tertiary",
  cool_neutral_l1: "primary",
  default_gradient: "tertiary",
  lawn_gradient: "tertiary",
  pool_gradient: "tertiary",
  primary_blue_gradient: "tertiary",
  orange_gradient: "tertiary"
};
